import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { initializeSupabase } from './config/localStorage'
import dayjs from 'dayjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import i18n from './locales'

// 在生产环境下拦截console输出
if (process.env.NODE_ENV === 'production') {
  const originalConsole = { ...console };
  console.log = function() {};
  console.info = function() {};
  console.warn = function() {};
  // 保留error日志，用于错误追踪
  console.error = function(...args) {
    originalConsole.error(...args);
  };
}

// 全局变量存储应用实例
let app = null

const showError = (message) => {
  const isDev = process.env.NODE_ENV === 'development';
  
  document.body.innerHTML = `
    <div style="text-align: center; padding: 20px; font-family: Arial, sans-serif;">
      <h1 style="color: #f56c6c;">系统提示</h1>
      <p style="color: #666; margin: 20px 0;">
        ${isDev ? message : '系统暂时无法访问，请稍后再试'}
      </p>
      ${isDev ? `
        <p style="color: #999;">
          可能的原因：<br>
          1. 网络连接问题<br>
          2. 本地存储服务初始化失败<br>
          3. 浏览器不支持本地存储
        </p>
      ` : ''}
      <button onclick="window.location.reload()" 
              style="padding: 10px 20px; background: #409eff; color: white; 
                     border: none; border-radius: 4px; cursor: pointer;">
        刷新页面
      </button>
      <p style="margin-top: 20px;">
        <a href="mailto:meta_translate@163.com" style="color: #409eff; text-decoration: none;">
          联系客服
        </a>
      </p>
    </div>
  `
}

const initApp = async () => {
  try {
    console.log('正在初始化应用...')
    app = createApp(App)

    // 初始化本地存储服务
    console.log('正在初始化本地存储服务...')
    const localStorageService = await initializeSupabase()
    
    // 全局配置
    app.config.globalProperties.$dayjs = dayjs
    app.config.globalProperties.$localStorage = localStorageService
    
    // 注册所有图标
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(key, component)
    }

    app.use(router)
    app.use(store)
    app.use(i18n)
    app.use(ElementPlus)

    // 等第一个路由解析完再挂载。
    // 否则第一帧 route.meta 还是空的，App.vue 的 isCyberPage/isCyberLayout 都为 false，
    // 会先按 CATTI 布局渲染一次——CATTI 菜单栏 + .app-container 的 #f5f5f5 灰底 +
    // overflow:hidden，而 router-view 里什么都还没有（首页是懒加载 chunk）。
    // 这个"灰底空屏"要一直挂到 Landing 的 chunk 到位；chunk 万一没回来就永远停在那儿。
    // 从别的路由点"主页"过来不会有这一帧，因为那时路由早就就绪了。
    // 单独 try：路由解析失败只记日志，不能让下面的 catch 把整个页面换成错误页。
    try {
      await router.isReady()
    } catch (routerError) {
      console.error('首个路由解析失败，仍继续挂载:', routerError)
    }

    console.log('应用初始化成功，正在挂载...')
    app.mount('#app')
    
    // 监听应用卸载
    window.addEventListener('beforeunload', () => {
      console.log('应用即将卸载')
    })
  } catch (error) {
    console.error('应用初始化失败:', error)
    showError(error.message || '发生未知错误，请刷新页面重试或联系管理员')
  }
}

// 启动应用
  initApp()
